import { FormControl } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { useSelector } from 'react-redux'
import { useActions } from '../../hooks/useActions'
import { useLocalization } from '../../redux/reduxHooks'
import { getLabel, pathToPerson, renderContent } from '../../utils/helpers'
import { PersonFieldPaths as paths } from '../../utils/QuestionnaireStateManager'
import Chooser from '../../widgets/Chooser'
import FollowUpQuestions from '../../widgets/FollowUpQuestions'
import { SubQuestionLabel } from '../../widgets/FormLabel'
import IntegerDetails from '../../widgets/IntegerDetails'

export const AgeAtMenopause = ({ label, ageAtMenopause, onChange }) => {
  return (
    <FormControl>
      <SubQuestionLabel>{label}</SubQuestionLabel>
      <IntegerDetails label={label} value={ageAtMenopause} onChange={onChange} />
    </FormControl>
  )
}

const Menopause = ({ id, patient = 'patient', config }) => {
  const localization = useLocalization()
  const sex = useSelector((state) => get(state, [...pathToPerson(id), 'sex'])) || ''
  const menopauseStatus =
    useSelector((state) =>
      get(state, [...pathToPerson(id), 'cancerRiskData', 'menopauseStatus']),
    ) || ''
  const ageAtMenopause =
    useSelector((state) => get(state, [...pathToPerson(id), 'cancerRiskData', 'ageAtMenopause'])) ||
    ''
  const { setPersonMenopauseStatus, setPersonAgeAtMenopause } = useActions()

  return sex === 'F' ? (
    <>
      <Chooser
        label={getLabel(localization, paths.MENOPAUSE_STATUS, 'patient')}
        onChange={(value) => {
          if (value !== menopauseStatus) {
            setPersonMenopauseStatus({ id, value })
            if (value !== 'Y') {
              setPersonAgeAtMenopause({ id, value: undefined })
            }
          }
        }}
        selectedValue={menopauseStatus}
        patient={patient}
        path={paths.MENOPAUSE_STATUS}
        orderSchema={['Y', 'inMenopause', 'N', 'unknown']}
      />
      {menopauseStatus === 'Y' ? (
        <FollowUpQuestions>
          {renderContent({
            renderMap: {
              menopauseAge: (
                <AgeAtMenopause
                  key="agm"
                  label={getLabel(localization, paths.AGE_AT_MENOPAUSE_LABEL, 'patient')}
                  ageAtMenopause={ageAtMenopause}
                  onChange={(value) => {
                    if (value !== ageAtMenopause) {
                      setPersonAgeAtMenopause({ id, value })
                    }
                  }}
                />
              ),
            },
            config,
          })}
        </FollowUpQuestions>
      ) : null}
    </>
  ) : null
}

export default Menopause
